import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  datePickerRoot: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      width: 'max(60%, 520px)',
      justifyContent: 'space-between',
      flexBasis: 4
    }
  },
  customRoot: {
    display: 'flex',
    maxWidth: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      width: 'max(60%, 520px)',
      justifyContent: 'space-between',
      flexBasis: 4
    }
  },
  item: {
    maxWidth: 300,
    [theme.breakpoints.down('sm')]: {
      margin: `${theme.spacing()}px 0`
    }
  }
}));